export enum Settings {
  AddClass = 'addclass',
  HasDivider = 'hasdivider',
  IsIdentified = 'isidentified',
  MediaTileType = 'mediatiletype',
  ThemeOverride = 'themeoverride',
  Width = 'width',    
  HeroType = 'herotype'
}
